import { render, staticRenderFns } from "./Warehouses.vue?vue&type=template&id=75a7c615&scoped=true&"
import script from "./Warehouses.vue?vue&type=script&lang=js&"
export * from "./Warehouses.vue?vue&type=script&lang=js&"
import style0 from "./Warehouses.vue?vue&type=style&index=0&id=75a7c615&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a7c615",
  null
  
)

export default component.exports